import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import React from 'react'
import { TyreWarrantyCheck, TyreWarrantyPath } from 'app/TyreWarranty/routes'

export const TyreWarrantyBreadCrumbs: React.FC = ({ ...props }: React.ComponentProps<typeof Breadcrumbs>) => {
  const { t } = useTranslation()

  const requestID = localStorage.getItem('tyreRequestID')

  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='crumb-conceptapp' key='crumb-conceptapp' path={TyreWarrantyPath} text={t('Tyre_Warranty.title')} />
      <Crumb
        data-testid='crumb-tyrewarranty-request'
        key='crumb-tyrewarranty-request'
        path={TyreWarrantyCheck}
        text={requestID as string}
      />
    </Breadcrumbs>
  )
}

export default TyreWarrantyBreadCrumbs
